/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component } from 'react';

import { withStyles, createTheme, ThemeProvider } from '@material-ui/core/styles'

import { Paper, Typography, TextField, Table, TableHead, TableBody, TableRow, TableCell, Divider, Button, CircularProgress } from '@material-ui/core'

import { dashboard_config } from './MtoTConfig';

import Action from '../../fluid/Actions/ActionFactory';

const blue_theme = createTheme({
    palette: {
      primary: {
        main: "#2296f3",
      },
      secondary: {
        main: "#dc014e",
      },
    },
});

const styles = theme => ({

})

class MtoTConfigScreen extends React.Component {
    state = {
        loading : false,
        dashboard_data : null,
        submitting : false
    }

    componentDidMount () {
        if (this.state.dashboard_data === null) {
            this.setState({...this.state, loading : true}, () => {
                Action('http_request', {
                    url : "/sainapse/configuration/dashboard_data",
                    method : 'get',
                    data : {}
                }).then(res => {
                    this.setState({...this.state, loading: false, dashboard_data : res.data.result.config.dashboard_data}, () => console.log("Dash Data :: Updated State :", this.state))
                }).catch(err => {
                    Action('http_request', {
                        url : "/sainapse/configuration/",
                        method : "post",
                        data : {
                            name : "dashboard_data",
                            config : {
                                dashboard_data : dashboard_config
                            }
                        }
                    }).then(res => {
                        Action('http_request', {
                            url : "/sainapse/configuration/dashboard_data",
                            method : 'get',
                            data : {}
                        }).then(res => {
                            this.setState({...this.state, loading: false, dashboard_data : res.data.result.config.dashboard_data}, () => console.log("Dash Data :: Updated State :", this.state))
                        })
                    }).catch(err => {

                    })
                })
            })
        }
    }

    updateConfig = (key_path, value) => {
        let dashboard_data = this.state.dashboard_data
        let config

        key_path.map((key, i) => {
            if (i === 0) {
                config = dashboard_data.find(cfg => cfg.key === key)
            } else {
                if (config.val_key === 'data') {
                    config = config[config.val_key].find(data => data.key === key)
                }
            }
        })

        config[config.val_key] = value
        this.setState({...this.state, dashboard_data : dashboard_data}, () => {
            console.log("Dash Data :: Updated State :", this.state)
            if (key_path[0] === 'mailbox') {
                let mailbox_data = this.getConfig(['mailbox']).options
                let email_data = mailbox_data.map(mailbox => {
                    return {
                        key: mailbox,
                        val_key : "data",
                        data : [
                            {
                                key : "YTD",
                                val_key : "value",
                                value : 0
                            },
                            {
                                key : "MTD",
                                val_key : "value",
                                value : 0
                            },
                            {
                                key : "WTD",
                                val_key : "value",
                                value : 0
                            },
                            {
                                key : "Today",
                                val_key : "value",
                                value : 0
                            }
                        ]
                    }
                })

                let dashboard_data = this.state.dashboard_data
                dashboard_data.find(data => data.key === 'number_emails_received').data = email_data
                this.setState({...this.state, dashboard_data : dashboard_data})
            } else if (key_path[0] === 'destination_crm') {
                let crm_data = this.getConfig(['destination_crm']).options
                let case_data = crm_data.map(crm => {
                    return {
                        key: crm,
                        val_key : "data",
                        data : [
                            {
                                key : "YTD",
                                val_key : "value",
                                value : 0
                            },
                            {
                                key : "MTD",
                                val_key : "value",
                                value : 0
                            },
                            {
                                key : "WTD",
                                val_key : "value",
                                value : 0
                            },
                            {
                                key : "Today",
                                val_key : "value",
                                value : 0
                            }
                        ]
                    }
                })

                let case_reco_data = crm_data.map(crm => {
                    return {
                        key: crm,
                        val_key : "data",
                        data : [
                            {
                                key : "YTD",
                                val_key : "value",
                                value : 0
                            },
                            {
                                key : "MTD",
                                val_key : "value",
                                value : 0
                            },
                            {
                                key : "WTD",
                                val_key : "value",
                                value : 0
                            },
                            {
                                key : "Today",
                                val_key : "value",
                                value : 0
                            }
                        ]
                    }
                })

                let dashboard_data = this.state.dashboard_data
                dashboard_data.find(data => data.key === 'number_emails_to_ticket').data = case_data
                dashboard_data.find(data => data.key === 'cases_recommendation').data = case_reco_data
                this.setState({...this.state, dashboard_data : dashboard_data})
            }
        })
    }

    getConfig = (key_path) => {
        let config

        key_path.map((key, i) => {
            if (i === 0) {
                config = this.state.dashboard_data.find(cfg => cfg.key === key)
            } else {
                if (config.val_key === 'data') {
                    config = config[config.val_key].find(data => data.key === key)
                }
            }
        })

        console.log("Dash Data :: Getting Config : ", config)
        return config
    }

    submitConfig = () => {
        this.setState({...this.state, submitting : true}, () => {
            Action('http_request', {
                url : "/sainapse/configuration/dashboard_data",
                method : 'put',
                data : {
                    name : "dashboard_data",
                    config : {
                        dashboard_data : this.state.dashboard_data
                    }
                }
            }).then(res => {
                this.setState({...this.state, submitting : false})
            })
        })
    }


    render() { 
        return (
            <ThemeProvider theme = {blue_theme}>
                <Paper square style = {{width : '100%', height : '50px', padding : '10px', display : 'flex', flexDirection : 'row', alignItems : 'center'}}>
                    <Typography style = {{flexGrow : 1}} variant = 'h6'>Dashboard Config</Typography>
                    <Button
                        color = 'primary'
                        variant = 'contained'
                        size = 'small'
                        onClick = {this.submitConfig}
                        startIcon = {this.state.submitting && <CircularProgress color = 'inherit' size = {20}/>}
                    >Submit</Button>
                </Paper>
                {this.state.dashboard_data && <div style = {{width : '100%', height : '90vh', display : 'flex', flexDirection : 'column', padding : '10px'}}>
                    <div style = {{width : '100%', padding : '10px', display : 'flex', flexDirection : 'row'}}>
                        <TextField
                            style = {{margin : '5px', width : '30%'}}
                            label = 'Customer'
                            helperText = "Enter Customer Name"
                            value = {this.getConfig(['customer_name']).value}
                            onChange = {(event) => this.updateConfig(['customer_name'], event.target.value)}
                        />
                        <TextField
                            style = {{margin : '5px', width : '30%'}}
                            label = 'Business Function'
                            helperText = "Enter Business Function"
                            value = {this.getConfig(['business_function']).value}
                            onChange = {(event) => this.updateConfig(['business_function'], event.target.value)}
                        />
                        <TextField
                            style = {{margin : '5px', width : '30%'}}
                            label = 'Geography'
                            helperText = "Enter Geography"
                            value = {this.getConfig(['geography']).value}
                            onChange = {(event) => this.updateConfig(['geography'], event.target.value)}
                        />
                    </div>
                    <Divider/>
                    <div style = {{width : '100%', padding : '10px', display : 'flex', flexDirection : 'row'}}>
                        <TextField
                            style = {{margin : '5px', width : '30%'}}
                            label = 'Mailbox'
                            helperText = "Enter Mailboxes"
                            value = {this.getConfig(['mailbox']).options}
                            onChange = {(event) => this.updateConfig(['mailbox'], event.target.value.split(','))}
                        />
                        <TextField
                            style = {{margin : '5px', width : '30%'}}
                            label = 'Destination CRM'
                            helperText = "Enter Destination CRM"
                            value = {this.getConfig(['destination_crm']).options}
                            onChange = {(event) => this.updateConfig(['destination_crm'], event.target.value.split(','))}
                        />
                    </div>
                    <Divider/>
                    <div style = {{width : '100%', padding : '10px'}}>
                        <Typography variant = 'subtitle2'>Number of Emails Received</Typography>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Mailbox</TableCell>
                                    <TableCell>YTD</TableCell>
                                    <TableCell>MTD</TableCell>
                                    <TableCell>WTD</TableCell>
                                    <TableCell>Today</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {this.getConfig(['number_emails_received']).data.map(data => {
                                    return (
                                        <TableRow>
                                            <TableCell>
                                                {data.key}
                                            </TableCell>
                                            <TableCell>
                                                <TextField
                                                    type = 'number'
                                                    value = {data.data.find(data => data.key === 'YTD').value}
                                                    onChange = {(event) => this.updateConfig(['number_emails_received', data.key, 'YTD'], Number(event.target.value))}
                                                />
                                            </TableCell>
                                            <TableCell>
                                                <TextField
                                                    type = 'number'
                                                    value = {data.data.find(data => data.key === 'MTD').value}
                                                    onChange = {(event) => this.updateConfig(['number_emails_received', data.key, 'MTD'], Number(event.target.value))}
                                                />
                                            </TableCell>
                                            <TableCell>
                                                <TextField
                                                    type = 'number'
                                                    value = {data.data.find(data => data.key === 'WTD').value}
                                                    onChange = {(event) => this.updateConfig(['number_emails_received', data.key, 'WTD'], Number(event.target.value))}
                                                />
                                            </TableCell>
                                            <TableCell>
                                                <TextField
                                                    type = 'number'
                                                    value = {data.data.find(data => data.key === 'Today').value}
                                                    onChange = {(event) => this.updateConfig(['number_emails_received', data.key, 'Today'], Number(event.target.value))}
                                                />
                                            </TableCell>
                                        </TableRow>
                                    )
                                })}
                            </TableBody>
                        </Table>
                    </div>
                    <Divider/>
                    <div style = {{width : '100%', padding : '10px'}}>
                        <Typography variant = 'subtitle2'>Number of Emails Converted to Case</Typography>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>CRM</TableCell>
                                    <TableCell>YTD</TableCell>
                                    <TableCell>MTD</TableCell>
                                    <TableCell>WTD</TableCell>
                                    <TableCell>Today</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {this.getConfig(['number_emails_to_ticket']).data.map(data => {
                                    return (
                                        <TableRow>
                                            <TableCell>
                                                {data.key}
                                            </TableCell>
                                            <TableCell>
                                                <TextField
                                                    type = 'number'
                                                    value = {data.data.find(data => data.key === 'YTD').value}
                                                    onChange = {(event) => this.updateConfig(['number_emails_to_ticket', data.key, 'YTD'], Number(event.target.value))}
                                                />
                                            </TableCell>
                                            <TableCell>
                                                <TextField
                                                    type = 'number'
                                                    value = {data.data.find(data => data.key === 'MTD').value}
                                                    onChange = {(event) => this.updateConfig(['number_emails_to_ticket', data.key, 'MTD'], Number(event.target.value))}
                                                />
                                            </TableCell>
                                            <TableCell>
                                                <TextField
                                                    type = 'number'
                                                    value = {data.data.find(data => data.key === 'WTD').value}
                                                    onChange = {(event) => this.updateConfig(['number_emails_to_ticket', data.key, 'WTD'], Number(event.target.value))}
                                                />
                                            </TableCell>
                                            <TableCell>
                                                <TextField
                                                    type = 'number'
                                                    value = {data.data.find(data => data.key === 'Today').value}
                                                    onChange = {(event) => this.updateConfig(['number_emails_to_ticket', data.key, 'Today'], Number(event.target.value))}
                                                />
                                            </TableCell>
                                        </TableRow>
                                    )
                                })}
                            </TableBody>
                        </Table>
                    </div> 
                    <Divider/>
                    <div style = {{width : '100%', padding : '10px'}}>
                        <Typography variant = 'subtitle2'>Cases with recommendations provided</Typography>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>CRM</TableCell>
                                    <TableCell>YTD</TableCell>
                                    <TableCell>MTD</TableCell>
                                    <TableCell>WTD</TableCell>
                                    <TableCell>Today</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {this.getConfig(['cases_recommendation']).data.map(data => {
                                    return (
                                        <TableRow>
                                            <TableCell>
                                                {data.key}
                                            </TableCell>
                                            <TableCell>
                                                <TextField
                                                    type = 'number'
                                                    value = {data.data.find(data => data.key === 'YTD').value}
                                                    onChange = {(event) => this.updateConfig(['cases_recommendation', data.key, 'YTD'], Number(event.target.value))}
                                                />
                                            </TableCell>
                                            <TableCell>
                                                <TextField
                                                    type = 'number'
                                                    value = {data.data.find(data => data.key === 'MTD').value}
                                                    onChange = {(event) => this.updateConfig(['cases_recommendation', data.key, 'MTD'], Number(event.target.value))}
                                                />
                                            </TableCell>
                                            <TableCell>
                                                <TextField
                                                    type = 'number'
                                                    value = {data.data.find(data => data.key === 'WTD').value}
                                                    onChange = {(event) => this.updateConfig(['cases_recommendation', data.key, 'WTD'], Number(event.target.value))}
                                                />
                                            </TableCell>
                                            <TableCell>
                                                <TextField
                                                    type = 'number'
                                                    value = {data.data.find(data => data.key === 'Today').value}
                                                    onChange = {(event) => this.updateConfig(['cases_recommendation', data.key, 'Today'], Number(event.target.value))}
                                                />
                                            </TableCell>
                                        </TableRow>
                                    )
                                })}
                            </TableBody>
                        </Table>
                    </div> 
                </div>}
            </ThemeProvider>
        );
    }
}
 
export default withStyles(styles)(MtoTConfigScreen);